

// src/redux/NannyproSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { BASE_URL, profileNannyById } from '../../utils/Constants';

// Async thunk for fetching data
export const getNannyProfileById = createAsyncThunk('getNannyProfileById', async (id) => {
  const token = localStorage.getItem("Token")
  const headers = {
    "Authorization": token,
    "Access-Control-Allow-Origin": "*",
    "Content-Type": "application/json",
  }
  try {
    const url = BASE_URL + `${profileNannyById}?id=${id}`
    const response = await axios.get(url, { headers }); // Replace with your API endpoint
    return response.data;
  } catch (error) {
    throw error;
  }
});

const NannyProfileByIdSlice = createSlice({
  name: 'nannyProfileByIdReducer',
  initialState: {
    data: null,
    loading: 'idle',
    error: null,
  },
  reducers: {
    clearData: (state) => {
      state.data = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getNannyProfileById.pending, (state) => {
        state.loading = 'pending';
      })
      .addCase(getNannyProfileById.fulfilled, (state, action) => {
        state.loading = 'idle';
        state.data = action.payload;
        state.error = null;
      })
      .addCase(getNannyProfileById.rejected, (state, action) => {
        state.loading = 'idle';
        state.error = action.error.message;
      });
  },
});
export const { clearData } = NannyProfileByIdSlice.actions
export default NannyProfileByIdSlice.reducer;
